"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n = require("@ms/yammer-i18n");
const safeStrs={teamsMeetingRemoveAppDisclaimer:1,teamsMeetingNotSetupOrganizerLearnMoreMessage:1};
exports.default = i18n.getStringInterpolator(safeStrs, 'teamsMeeting');
